/* global  moment, _ */
import './style.less';
import { get } from 'lodash';

export default function($log, $filter, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  const { company } = ProfileClass.profileComplete;
  const applyApprovedOnly = get(company, 'preferences.certificates.applyApprovedOnly', false);

  vm.tableConfig = {
    isOpen: false,
    select: true,
    fixed_columns_count: 8,
    fixed_columns: {
      approved: {
        active: true,
        visible: applyApprovedOnly,
        style: 'min-width: 100px;',
        text: 'Admin Approved'
      },
      date: {
        active: true,
        visible: true,
        style: 'min-width: 100px;',
        text: 'Date'
      },
      cert_id: {
        active: true,
        visible: true,
        style: 'min-width: 100px;',
        text: 'ID'
      },
      cert: {
        active: true,
        visible: true,
        style: 'min-width: 400px;',
        text: 'Title'
      },
      delivery: {
        active: true,
        visible: true,
        style: 'min-width: 200px;',
        text: 'Delivery Method'
      },
      sponsors: {
        active: true,
        visible: true,
        style: 'min-width: 200px;',
        text: 'Sponsor'
      },
      hours: {
        active: true,
        visible: true,
        style: 'min-width: 200px;',
        text: 'Hours'
      },
      pdf: {
        active: true,
        visible: true,
        style: 'min-width: 100px;',
        text: 'PDF'
      }
    },
    license_columns: {},
    selectAll: function(license) {
      for (const regulator in this.license_columns.all_headers) {
        const { reg_id } = this.license_columns.all_headers[regulator];
        if (reg_id === license) {
          this.license_columns.all_headers[regulator].active = !this.license_columns.all_headers[regulator].active; // keep ! for binding
        }
        if (!license) {
          this.license_columns.all_headers[regulator].active = !!this.select; // keep !! for binding
        }
      }

      for (const regulator in this.license_columns.all_columns) {
        const { reg_id } = this.license_columns.all_columns[regulator];
        if (reg_id === license) {
          this.license_columns.all_columns[regulator].active = !this.license_columns.all_columns[regulator].active; // keep ! for binding
        }
        if (!license) {
          this.license_columns.all_columns[regulator].active = !!this.select; // keep !! for binding
        }
      }

      if (license) return; // Exit early for license

      for (const column in this.fixed_columns) {
        this.fixed_columns[column].active = !!this.select; // keep !! for binding
      }

      this.select = !this.select;
      this.fixedColumnCountChange();
    },
    fixedColumnChange: function(column) {
      column.active = !column.active;

      this.fixedColumnCountChange();
    },
    fixedColumnCountChange: function() {
      let tempCount = 0;

      for (const column in this.fixed_columns) {
        if (this.fixed_columns[column].active && this.fixed_columns[column].visible) {
          tempCount++;
        }
      }

      this.fixed_columns_count = tempCount;
    }
  };

  vm.tableConfig.fixedColumnCountChange();

  // set default value for showing expanded license information
  function showExpanded() {
    return !!vm.regulator;
  }

  function columnTemplate(name) {
    return {
      active: showExpanded(),
      columns: {},
      colspan: 0,
      text: name
    };
  }

  function categoryTemplate(category, reg_id, colspan = 1, css) {
    return {
      active: showExpanded(),
      category,
      reg_id,
      style: 'min-width: 125px',
      creditKey: `${reg_id}_${category}`,
      css,
      colspan,
      text: $filter('CategoryName')(category)
    };
  }

  function categoryHeaderTemplate(text, reg_id, colspan = 1) {
    return {
      active: showExpanded(),
      colspan,
      reg_id,
      text
    };
  }

  function generateLicenseColumns(licenses) {
    vm.tableConfig.license_columns = {};

    for (const license of licenses) {
      const { hour_categories, reg_id, cyc_yr, name } = license;

      if (!vm.tableConfig.license_columns[reg_id])
        vm.tableConfig.license_columns[reg_id] = { all: columnTemplate(name) };
      if (!vm.tableConfig.license_columns[reg_id][cyc_yr])
        vm.tableConfig.license_columns[reg_id][cyc_yr] = columnTemplate(name);

      for (const category in hour_categories) {
        if (!vm.tableConfig.license_columns[reg_id][cyc_yr].columns[category]) {
          vm.tableConfig.license_columns[reg_id][cyc_yr].colspan++;
          vm.tableConfig.license_columns[reg_id][cyc_yr].columns[category] = categoryTemplate(category, reg_id);
        }

        if (!vm.tableConfig.license_columns[reg_id].all.columns[category]) {
          vm.tableConfig.license_columns[reg_id].all.colspan++;
          vm.tableConfig.license_columns[reg_id].all.columns[category] = categoryTemplate(category, reg_id);
        }
      }
    }

    for (const regId in vm.tableConfig.license_columns) {
      if (!vm.tableConfig.license_columns.all_headers) vm.tableConfig.license_columns.all_headers = [];
      if (!vm.tableConfig.license_columns.all_columns) vm.tableConfig.license_columns.all_columns = [];

      const { colspan, text } = vm.tableConfig.license_columns[regId].all;

      vm.tableConfig.license_columns.all_headers.push(categoryHeaderTemplate(text, regId, colspan));

      Object.keys(vm.tableConfig.license_columns[regId].all.columns).forEach((column, index, array) => {
        let css = '';

        if (index == 0) {
          if (!css) css += 'border';
          css += '-left';
        }
        if (index == array.length - 1) {
          if (!css) css += 'border';
          css += '-right';
        }

        vm.tableConfig.license_columns.all_columns.push(
          categoryTemplate(vm.tableConfig.license_columns[regId].all.columns[column].category, regId, undefined, css)
        );
      });
    }
  }

  function generateCertificatesDict(certificates) {
    return certificates.reduce((obj, cert) => {
      if (!obj[cert.cert_id]) obj[cert.cert_id] = {};

      if (!cert.hours_applied || !Object.keys(cert.hours_applied).length) return obj;

      Object.keys(cert.hours_applied).forEach(lic_yr => {
        const reg_id = lic_yr.slice(0, -5);

        Object.keys(cert.hours_applied[lic_yr]).forEach(category => {
          obj[cert.cert_id][`${reg_id}_${category}`] = cert.hours_applied[lic_yr][category];
        });
      });

      return obj;
    }, {});
  }

  function activate() {
    $log.debug('Event Basic Table Component Activated');

    const licenses = vm.regulator ? [vm.regulator] : vm.licenses;

    generateLicenseColumns(licenses);
    vm.certificatesAppliedDict = generateCertificatesDict(vm.certificates);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/report/reportsCertificateTable/controller.js